import {
  SET_PURPOSEOFTRANSFER,
  SET_PURPOSEOFTRANSFERNAME,
  GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST,
  GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS,
  GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE,
  CLEANUP,
} from "./selectPurposeOfTransferType";

const initialState = {
  loading: false,
  purposeOfTransfer: null,
  purposeOfTransferName: null,
  allowedPurposeOfTransfers: [],
  error: "",
};

const selectPurposeOfTransferReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEANUP: {
      return initialState;
    }

    case SET_PURPOSEOFTRANSFER: {
      return {
        ...state,
        purposeOfTransfer: action.purposeOfTransfer,
      };
    }

    case SET_PURPOSEOFTRANSFERNAME: {
      return {
        ...state,
        purposeOfTransferName: action.purposeOfTransferName,
      };
    }

    case GET_ALLOWED_PURPOSEOFTRANSFERS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_ALLOWED_PURPOSEOFTRANSFERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        allowedPurposeOfTransfers: action.payload,
        error: "",
      };
    }

    case GET_ALLOWED_PURPOSEOFTRANSFERS_FAILURE: {
      return {
        ...state,
        loading: false,
        allowedPurposeOfTransfers: [],
        error: action.payload,
      };
    }

    default:
      return state;
  }
};

export default selectPurposeOfTransferReducer;
